@let readOnly = $readOnly();

<form [formGroup]="formGroup">
  <div class="x-card x-card_size_m x-white card-shadow">
    <p class="x-island-header">
      {{ 'request_form.common.managers.title' | translate }}
    </p>

    <div class="x-input-label">
      {{ 'request_form.common.managers.support_manager_fullname' | translate }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          [formControlName]="FormFields.SupportManagerFullname"
          tuiInput
          [readOnly]="readOnly"
        />
      </tui-textfield>
    </div>

    <div class="x-input-label">
      {{
        'request_form.common.managers.support_manager_phone_number' | translate
      }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          [formControlName]="FormFields.SupportManagerPhone"
          tuiInput
          [readOnly]="readOnly"
        />
      </tui-textfield>
    </div>

    <div class="x-input-label">
      {{ 'request_form.common.managers.client_manager_fullname' | translate }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          [formControlName]="FormFields.ClientManagerFullname"
          tuiInput
          [readOnly]="readOnly"
        />
      </tui-textfield>
    </div>

    <div class="x-input-label">
      {{
        'request_form.common.managers.client_manager_phone_number' | translate
      }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          [formControlName]="FormFields.ClientManagerPhone"
          tuiInput
          [readOnly]="readOnly"
        />
      </tui-textfield>
    </div>

    <div class="x-input-label">
      {{ 'request_form.common.managers.client_manager_email' | translate }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          [formControlName]="FormFields.ClientManagerEmail"
          tuiInput
          [readOnly]="readOnly"
        />
      </tui-textfield>
    </div>
  </div>
</form>
